
<div class="card dev-card">

  <div class="dev-header">
    <h2 class="dev-title">Pédiatrie : Dev. Psychomoteur</h2>

    <div class="dev-toolbar">
      <div class="dev-legend">
        <span class="legend-item">
          <span class="dot dot-history"></span>
          Historique
        </span>
        <span class="legend-item">
          <span class="dot dot-due"></span>
          À évaluer
        </span>
        <span class="legend-item">
          <span class="dot dot-upcoming"></span>
          À venir
        </span>
        <span class="legend-item">
          <span class="dot dot-done"></span>
          Acquis
        </span>
      </div>

      <div class="dev-actions">
        <button type="button" class="btn-link-action"
                (click)="expandAll()">
          Tout ouvrir
        </button>
        <button type="button" class="btn-link-action"
                (click)="collapseAll()">
          Tout fermer
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="dev-empty">
    Chargement...
  </div>

  <div *ngIf="!loading && !developmentGroups.length"
       class="dev-empty">
    Aucun repère disponible.
  </div>

  <div class="dev-scroll" *ngIf="!loading">
    <div *ngFor="let group of developmentGroups; trackBy: trackByGroup"
         class="dev-group"
         [class.is-open]="isOpen(group.minOld)">

      <div class="group-row">
        <div>
          <button type="button"
                  class="group-toggle"
                  (click)="toggleGroup(group.minOld)">
            <span class="chevron"></span>

            <span class="group-label">{{ group.label }}</span>

            <span class="group-count"
                  [class.complete]="getTotalCount(group) > 0 &&
                    getCheckedCount(group) === getTotalCount(group)">
              {{ getCheckedCount(group) }}/{{ getTotalCount(group) }}
            </span>
          </button>
        </div>
      </div>

      <div *ngIf="isOpen(group.minOld)" class="table-responsive">
        <table class="table dev-table">
          <colgroup>
            <col class="col-label">
            <col class="col-comment">
            <col class="col-date">
            <col class="col-done">
          </colgroup>

          <thead>
            <tr>
              <th>Repère</th>
              <th>Observation</th>
              <th>Date</th>
              <th class="text-center">Fait</th>
            </tr>
          </thead>

          <tbody>
            <!-- Historique : lecture seule -->
            <tr *ngFor="let item of group.historyItems; trackBy: trackByItem"
                class="dev-row row-history">

              <td class="cell-label">
                {{ item.setting?.label }}
              </td>

              <td class="cell-muted">
                {{ item.comment || '—' }}
              </td>

              <td class="cell-muted">
                {{ getDisplayDate(item) }}
              </td>

              <td class="text-center">
                <span class="status-icon"
                      [class.ok]="item.developmentEvaluated"
                      [class.ko]="!item.developmentEvaluated">
                  {{ item.developmentEvaluated ? '✓' : '—' }}
                </span>
              </td>
            </tr>

            <!-- Consultation actuelle : assign ou update -->
            <tr *ngFor="let item of group.formItems; trackBy: trackByItem"
                class="dev-row"
                [ngClass]="getRowClass(item)"
                [class.row-locked]="isItemDisabled(item)"
                [title]="getDisabledReason(item)">

              <td class="cell-label">
                {{ item.setting?.label }}

                <span *ngIf="isItemDisabled(item)" class="lock-icon">
                  🔒
                </span>
              </td>

              <td>
                <input type="text"
                       class="form-control form-control-sm"
                       [(ngModel)]="item.comment"
                       [ngModelOptions]="{standalone: true}"
                       [disabled]="isItemDisabled(item)"
                       placeholder="Observation"
                       (ngModelChange)="onItemChange(item)">
              </td>

              <td>
                <input type="date"
                       class="form-control form-control-sm dev-date"
                       [ngModel]="getInputDate(item)"
                       [ngModelOptions]="{standalone: true}"
                       [disabled]="isItemDisabled(item)"
                       (ngModelChange)="onDateChange(item, $event)">
              </td>

<td class="text-center">
  <input
    type="checkbox"
    class="dev-checkbox"
    [(ngModel)]="item.developmentEvaluated"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="isItemDisabled(item)"
    (ngModelChange)="onItemChange(item)"
  />
</td>   <!-- manquant -->

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
